<template>
  <div>
    <div class="flex flex-wrap mt-4">
      <div class="w-full mb-12 xl:mb-0 px-4">
        <card-activities />
      </div>
    </div>
  </div>
</template>
<script>
import CardActivities from "@/components/Dashboard/CardActivities.vue";
export default {
  name: "dashboard-page",
  components: {
    CardActivities
  },
};
</script>
